import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import get from 'lodash/get';
import FormInputTable from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import FormDoubleInput from 'components/blocks/ManagementNewForms/Inputs/FormDoubleInput';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import useCreateDeclaracionJuradaViolenciaGenero from 'services/record/DeclaracionJuradaViolenciaGenero/useCreateDeclaracionJuradaViolenciaGenero';
import useUpdateDeclaracionJuradaViolenciaGeneroByID from 'services/record/DeclaracionJuradaViolenciaGenero/useUpdateDeclaracionJuradaViolenciaGenero';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';



const DeclaracionJuradaViolenciaGenero = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createDeclaracionJuradaViolenciaGenero, dataCreateDeclaracionJuradaViolenciaGenero, errorCreateDeclaracionJuradaViolenciaGenero, loadingCreateDeclaracionJuradaViolenciaGenero, successCreateDeclaracionJuradaViolenciaGenero } = useCreateDeclaracionJuradaViolenciaGenero();
    const { dataUpdateDeclaracionJuradaViolenciaGeneroById, errorUpdateDeclaracionJuradaViolenciaGeneroById, loadingUpdateDeclaracionJuradaViolenciaGeneroById, successUpdateDeclaracionJuradaViolenciaGeneroById, updateDeclaracionJuradaViolenciaGeneroById } = useUpdateDeclaracionJuradaViolenciaGeneroByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    const ingresosPeriodoAnterior = watch('CeseParcial.IngresosPeriodoAnterior');



    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {

            reset({
                // =====================================================
                // DATOS PERSONALES
                // =====================================================
                DatosPersonales: {
                    SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
                    SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
                    SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
                    SolicitanteIPF: data?.DatosPersonales?.IPF || "",
                    SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",
                    SolicitanteNombreCompleto: data?.DatosPersonales?.Nombre + " " + data?.DatosPersonales?.Apellido1 + " " + data?.DatosPersonales?.Apellido2 || "",

                    SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
                    SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
                    SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
                    SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
                    SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
                    SolicitanteProvinciaDescripcion: data?.DatosPersonales?.Provincia || "",
                    SolicitanteComunidadCodigo: data?.DatosPersonales?.ComunidadCodigo || "",
                    SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
                },

                // =====================================================
                // CAUSA CESE
                // =====================================================
                CausaCese: {
                    TipoMotivoCeseActividad:
                        data?.MotivoCeseActividad != null
                            ? data.MotivoCeseActividad.toString()
                            : null,

                    FechaMotivoCese:
                        data?.FechaMotivoCese || null,

                    EstablecimientoMercantil:
                        data?.TitularEstablecimiento ?? false,

                    DomicilioEstablecimiento:
                        data?.DomicilioEstablecimiento || null
                },

                // =====================================================
                // FUERZA MAYOR
                // =====================================================
                FuerzaMayor: {
                    Causa:
                        data?.FuerzaMayor?.Causa || "",

                    Caracter:
                        data?.FuerzaMayor?.Caracter != null
                            ? data.FuerzaMayor.Caracter.toString()
                            : null
                },

                // =====================================================
                // VIOLENCIA DE GÉNERO
                // =====================================================
                Violencia: {
                    Causa:
                        data?.ViolenciaGenero?.Causa || "",

                    Caracter:
                        data?.ViolenciaGenero?.Caracter != null
                            ? data.ViolenciaGenero.Caracter.toString()
                            : null
                },

                // =====================================================
                // CESE PARCIAL / TEMPORAL
                // =====================================================
                CeseParcial: {
                    Causa:
                        data?.CeseTemporalParcial?.Causa || "",

                    PeriodoCalculo:
                        data?.CeseTemporalParcial?.PeriodoCalculo || "",

                    IngresosPeriodo:
                        data?.CeseTemporalParcial?.IngresosPeriodo != null
                            ? data.CeseTemporalParcial.IngresosPeriodo.toString()
                            : "",

                    IngresosPeriodoAnterior:
                        data?.CeseTemporalParcial?.IngresosPeriodoAnterior != null
                            ? data.CeseTemporalParcial.IngresosPeriodoAnterior.toString()
                            : "",

                    CalculoPorcentaje:
                        data?.CeseTemporalParcial?.SetentaYCincoPorCiento != null
                            ? data.CeseTemporalParcial.SetentaYCincoPorCiento.toString()
                            : ""
                },
            });
        }

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);

    useEffect(() => {
        if (
            ingresosPeriodoAnterior !== undefined &&
            ingresosPeriodoAnterior !== null &&
            ingresosPeriodoAnterior !== ''
        ) {
            const valorNumerico = Number(ingresosPeriodoAnterior);

            if (!isNaN(valorNumerico)) {
                const calculo75 = +(valorNumerico * 0.75).toFixed(2);

                setValue(
                    'CeseParcial.CalculoPorcentaje',
                    calculo75.toString(),
                    { shouldValidate: true, shouldDirty: true }
                );
            }
        } else {
            // Limpia el campo D si C queda vacío
            setValue('CeseParcial.CalculoPorcentaje', '');
        }
    }, [ingresosPeriodoAnterior, setValue]);


    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;


        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,

            // =====================================================
            // DATOS PERSONALES
            // =====================================================
            datosPersonales: {
                nombre: dataUser?.DatosPersonales?.Nombre ?? dataUser?.datosPersonales?.nombre ?? "",
                apellido1: dataUser?.DatosPersonales?.Apellido1 ?? dataUser?.datosPersonales?.apellido1 ?? "",
                apellido2: dataUser?.DatosPersonales?.Apellido2 ?? dataUser?.datosPersonales?.apellido2 ?? "",
                ipf: dataUser?.DatosPersonales?.IPF ?? dataUser?.datosPersonales?.ipf ?? "",
                ipfTipo: dataUser?.DatosPersonales?.IPFTipo ?? dataUser?.datosPersonales?.ipfTipo ?? 1,
                telefono: dataUser?.DatosPersonales?.Telefono ?? dataUser?.datosPersonales?.telefono ?? "",
                fijo: dataUser?.DatosPersonales?.Fijo ?? dataUser?.datosPersonales?.fijo ?? "",
                domicilio: dataUser?.DatosPersonales?.Domicilio ?? dataUser?.datosPersonales?.domicilio ?? "",
                codigoPostal: dataUser?.DatosPersonales?.CodigoPostal ?? dataUser?.datosPersonales?.codigoPostal ?? "",
                provinciaDescripcion: dataUser?.DatosPersonales?.ProvinciaDescripcion ?? dataUser?.DatosPersonales?.Provincia ?? dataUser?.datosPersonales?.provinciaDescripcion ?? "",
                codigoProvincia: dataUser?.DatosPersonales?.CodigoProvincia ?? dataUser?.datosPersonales?.codigoProvincia ?? "",
                codigoLocalidad: dataUser?.DatosPersonales?.CodigoLocalidad ?? dataUser?.datosPersonales?.codigoLocalidad ?? "",
                localidadDescripcion: dataUser?.DatosPersonales?.LocalidadDescripcion ?? dataUser?.datosPersonales?.localidadDescripcion ?? "",
                numeroSeguridadSocial: dataUser?.DatosPersonales?.NumeroSeguridadSocial ?? dataUser?.datosPersonales?.numeroSeguridadSocial ?? ""
            },

            // =====================================================
            // CAUSA CESE
            // =====================================================
            MotivoCeseActividad:
                data?.CausaCese?.TipoMotivoCeseActividad != null
                    ? parseInt(data.CausaCese.TipoMotivoCeseActividad)
                    : null,

            FechaMotivoCese:
                data?.CausaCese?.FechaMotivoCese || null,

            titularEstablecimiento:
                data?.CausaCese?.EstablecimientoMercantil ?? false,

            domicilioEstablecimiento:
                data?.CausaCese?.DomicilioEstablecimiento || null,

            // =====================================================
            // FUERZA MAYOR
            // =====================================================
            fuerzaMayor: parseInt(data?.CausaCese?.TipoMotivoCeseActividad) === 0 ? {
                causa: data?.FuerzaMayor?.Causa || "",
                caracter:
                    data?.FuerzaMayor?.Caracter != null
                        ? parseInt(data.FuerzaMayor.Caracter)
                        : null
            } : null,

            // =====================================================
            // VIOLENCIA DE GÉNERO
            // =====================================================
            violenciaGenero: parseInt(data?.CausaCese?.TipoMotivoCeseActividad) === 2 ?{
                causa: data?.Violencia?.Causa || "",
                caracter:
                    data?.Violencia?.Caracter != null
                        ? parseInt(data.Violencia.Caracter)
                        : null
            } : null,

            // =====================================================
            // CESE TEMPORAL / PARCIAL
            // =====================================================
            ceseTemporalParcial: parseInt(data?.CausaCese?.TipoMotivoCeseActividad) === 1 ? {
                causa: data?.CeseParcial?.Causa || "",
                periodoCalculo: data?.CeseParcial?.PeriodoCalculo || "",

                ingresosPeriodo:
                    data?.CeseParcial?.IngresosPeriodo !== ""
                        ? Number(data.CeseParcial.IngresosPeriodo)
                        : 0,

                ingresosPeriodoAnterior:
                    data?.CeseParcial?.IngresosPeriodoAnterior !== ""
                        ? Number(data.CeseParcial.IngresosPeriodoAnterior)
                        : 0,

                calculo75Porciento:
                    data?.CeseParcial?.CalculoPorcentaje !== ""
                        ? Number(data.CeseParcial.CalculoPorcentaje)
                        : 0
            } : null,

            // =====================================================
            // DOCUMENTACIÓN 
            // =====================================================
            documentacion: []
        };


        if (info) {
            await createDeclaracionJuradaViolenciaGenero(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            await updateDeclaracionJuradaViolenciaGeneroById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }



        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreateDeclaracionJuradaViolenciaGenero || loadingUpdateDeclaracionJuradaViolenciaGeneroById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FieldsetContainer legend="" disabled={false}>
                    <p className='mt-2 mb-2 parra-bold'>En virtud de la prescripción recogida en el Título V “protección por cese de actividad” del RD Legislativo 8/2015 de 30 de octubre por el que se
                        aprueba el TRLGSS, en cuyo artículo 332 se determina la forma de acreditación de la situación legal de cese de la actividad en cada uno de los
                        supuestos tasados que se enumeran en el artículo 331 del mismo cuerpo legal, se certifica lo siguiente</p>
                    <p className='mt-2 mb-2 text-left parra-bold'>D./Dña
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNombreCompleto"
                            inputType={1}
                            disabled={true}
                            minWidth={300}
                        />

                        con número de afiliación a la Seguridad Social
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteNumeroSS"
                            inputType={1}
                            disabled={true}
                        />
                        con DNI/NIF/pasaporte/NIE número
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteIPF"
                            inputType={1}
                            disabled={true}
                        />
                        y domicilio en
                        <InputTextIntegration
                            name="DatosPersonales.SolicitanteDomicilio"
                            inputType={1}
                            disabled={true}
                            minWidth={500}
                        />
                        declara bajo su responsabilidad que:
                    </p>

                </FieldsetContainer>
                <div className='m-3'></div>

                <AccordionForm title={'Causa del Cese de la Actividad'} expandedInit={false} nombreError='CausaCese' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputRadioGroup
                                    title="En su condición de trabajador/a autónomo/a declara que ha cesado el ejercicio de su actividad por alguna de estas causas (márquese la que procesa):"
                                    name="CausaCese.TipoMotivoCeseActividad"
                                    required='Debe seleccionar una causa'
                                    labels={["Por la concurrencia de motivos basados en fuerza mayor del cese de actividad económica o profesional", "Por la concurrencia de motivos basados en fuerza mayor en el cese temporal parcial", "Por la concurrencia de motivos basados en violencia de género o violencia sexual"]}
                                    col={12}
                                    modal={["", "cuando la interrupción de la actividad de la empresa afecte a un sector o centro de trabajo"]}
                                />
                                <AccordionDisplay dataUser={dataUser} visibility={watch('CausaCese.TipoMotivoCeseActividad') === '0'} fields={['FuerzaMayor.Causa', 'FuerzaMayor.Caracter']}>
                                    <FormInputText
                                        name='FuerzaMayor.Causa'
                                        id='FuerzaMayor.Causa'
                                        label='Por la concurrencia de motivos basados en fuerza mayor determinante del cese de actividad económica o profesional, siendo la causa:'
                                        req={watch('CausaCese.TipoMotivoCeseActividad') === '0' ? 'Debe indicar la causa' : null}
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                    />
                                    <FormInputRadioGroup
                                        title="Carácter:"
                                        name="FuerzaMayor.Caracter"
                                        required={watch('CausaCese.TipoMotivoCeseActividad') === '0' ? 'Debe seleccionar el carácter de la fuerza mayor' : null}
                                        labels={["Temporal", "Definitivo"]}
                                        col={12}
                                    />
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('CausaCese.TipoMotivoCeseActividad') === '2'} fields={['Violencia.Causa', 'Violencia.Caracter']}>
                                    <FormInputText
                                        name='Violencia.Causa'
                                        id='Violencia.Causa'
                                        label='Por la concurrencia de motivos basados en violencia de género o violencia sexual'
                                        req={watch('CausaCese.TipoMotivoCeseActividad') === '2' ? 'Debe indicar la causa' : null}
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                    />
                                    <FormInputRadioGroup
                                        title="Carácter:"
                                        name="Violencia.Caracter"
                                        required={watch('CausaCese.TipoMotivoCeseActividad') === '2' ? 'Debe indicar el carácter' : null}
                                        labels={["Temporal", "Definitivo"]}
                                        col={12}
                                    />
                                </AccordionDisplay>
                                <AccordionDisplay dataUser={dataUser} visibility={watch('CausaCese.TipoMotivoCeseActividad') === '1'} fields={['CeseParcial.PeriodoCalculo', 'CeseParcial.Causa', 'CeseParcial.IngresosPeriodo', 'CeseParcial.IngresosPeriodoAnterior', 'CeseParcial.CalculoPorcentaje']}>
                                    <FormInputText
                                        name='CeseParcial.Causa'
                                        id='CeseParcial.Causa'
                                        req={watch('CausaCese.TipoMotivoCeseActividad') === '1' ? 'Debe indicar la causa del cese temporal parcial' : null}
                                        label='Por la concurrencia de motivos basados en fuerza mayor en el cese temporal parcial, cuando la interrupción de la actividad de la empresa afecte a un sector o centro de trabajo y cumpla con los siguientes requisitos'
                                        md={12}
                                        xl={12}
                                        disabled={false}
                                    />
                                    <p className='mt-4 mb-2'>
                                        Declaro cumplir con los requisitos:
                                        <br />- Exista una declaración de emergencia adoptada por la autoridad pública competente.
                                        <br />- Y se produzca una caída de ingresos del 75% de la actividad de la empresa con relación al mismo periodo del año anterior.
                                    </p>
                                    <FormDoubleInput
                                        label={'A-Periodo para el cálculo de la reducción de ingresos'}
                                        name={'CeseParcial.PeriodoCalculo'}
                                        disabled={false}
                                        inputTypes={[1, 1]}
                                        double={false}
                                        modal={''}
                                        required={[watch('CausaCese.TipoMotivoCeseActividad') === '1' ? 'Debe indicar el periodo de cálculo' : null]}
                                    />
                                    <FormDoubleInput
                                        label={'B-Ingresos de dicho periodo'}
                                        name={'CeseParcial.IngresosPeriodo'}
                                        disabled={false}
                                        inputTypes={[3, 1]}
                                        double={false}
                                        modal={''}
                                        required={[watch('CausaCese.TipoMotivoCeseActividad') === '1' ? 'Debe indicar los ingresos del periodo' : null]}
                                    />
                                    <FormDoubleInput
                                        label={'C-Ingresos del mismo periodo en el año anterior'}
                                        name={'CeseParcial.IngresosPeriodoAnterior'}
                                        disabled={false}
                                        inputTypes={[3, 1]}
                                        double={false}
                                        modal={''}
                                        required={[watch('CausaCese.TipoMotivoCeseActividad') === '1' ? 'Debe indicar los ingresos del periodo anterior' : null]}
                                    />
                                    <FormDoubleInput
                                        label={'D-Cálculo del 75% (del apartado C)'}
                                        name={'CeseParcial.CalculoPorcentaje'}
                                        disabled={true}
                                        inputTypes={[3, 1]}
                                        double={false}
                                        modal={''}
                                        
                                    />
                                    <p className='mt-4 mb-2'>
                                        B &lt; D
                                        <br />
                                        - y los ingresos mensuales del trabajador autónomo no alcance el salario mínimo interprofesional o el importe de la
                                        base por la que viniera cotizando si esta fuera inferior.
                                    </p>

                                </AccordionDisplay>
                                <div className='m-4'></div>
                                <p>
                                    Del mismo modo, hace constar que la fecha en la que se ha producido el motivo aducido es:
                                    <InputTextIntegration
                                        name="CausaCese.FechaMotivoCese"
                                        inputType={4}
                                        req='La fecha del motivo deberia'
                                        disabled={false}
                                        minWidth={150}
                                    />
                                </p>

                                <div className='m-4'></div>

                                <FormInputCheckboxTable
                                    title="Es titular de un establecimiento mercantil, industrial o de otra naturaleza abierto al público"
                                    names={["CausaCese.EstablecimientoMercantil"]}
                                    labels={[
                                        "Marquese si procede"
                                    ]}
                                    col={12}
                                />





                                <AccordionDisplay dataUser={dataUser} visibility={watch('CausaCese.EstablecimientoMercantil') === true} fields={['CeseActividad.DomicilioEstablecimiento']}>

                                    <p>
                                        Es titular de un establecimiento mercantil, industrial o de otra naturaleza abierto al público, situado en (indique
                                        dirección completa):
                                        <InputTextIntegration
                                            name="CausaCese.DomicilioEstablecimiento"
                                            inputType={1}
                                            disabled={false}
                                            minWidth={300}
                                        />
                                        el cual permanecerá cerrado durante todo el período en
                                        el que perciba prestación económica por cese de actividad.
                                    </p>
                                </AccordionDisplay>
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>
















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateDeclaracionJuradaViolenciaGenero}
                    successUpdate={successUpdateDeclaracionJuradaViolenciaGeneroById}
                    errorCreate={errorCreateDeclaracionJuradaViolenciaGenero}
                    errorUpdate={errorUpdateDeclaracionJuradaViolenciaGeneroById}
                    datosAPI={datosAPI}
                    info={info}
                    BloqueoForm={[1]}
                    label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, al día de la fecha, los datos declarados siguen siendo vigentes, informándose que, en caso de resultar inciertos, la Mutua se reserva el derecho de reclamación de la prestación a que hubiera dado lugar'
                />


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default DeclaracionJuradaViolenciaGenero
